var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"my-3",attrs:{"rounded":"lg","outlined":""}},[_c('v-skeleton-loader',{attrs:{"type":"list-item-avatar-two-line"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }